

let FlagOfset = 0;

const DONOTHING = 1 << FlagOfset++;
const BREAK_FLOW = 1 << FlagOfset++;
const LOCAL_TRANSFORM = 1 << FlagOfset++;
const WORLD_TRANSFORM = 1 << FlagOfset++;
const TRANSFORM = LOCAL_TRANSFORM | WORLD_TRANSFORM;
const UPDATE_RENDER_DATA = 1 << FlagOfset++;
const OPACITY = 1 << FlagOfset++;
const COLOR = 1 << FlagOfset++;
const OPACITY_COLOR = OPACITY | COLOR;
const RENDER = 1 << FlagOfset++;
const CHILDREN = 1 << FlagOfset++;
const POST_RENDER = 1 << FlagOfset++;
const FINAL = 1 << FlagOfset++;


// let initRender = function() {
//     if (cc.RenderFlow.prototype["_childrenClone"]) return;
//     cc.RenderFlow.prototype["_childrenClone"] = cc.RenderFlow.prototype["_children"];
//     cc.RenderFlow.prototype["_children"] = function (node) {
//         let oriChildren = node._children;
//         if (node._renderChildren) {
//             node._children = node._renderChildren;
//             let children = node._renderChildren;
//             node._opacity /= 255;
//             for (var i = 0, l = children.length; i < l; i++) {
//                 var c = children[i];
//                 c._renderFlag &= ~CHILDREN;
//             }
//         }
//         this._childrenClone(node);

//         if (node._renderChildren) {
//             node._children = oriChildren;
//             node._opacity *= 255;

//             let children = node._renderChildren;
//             for (var i = 0, l = children.length; i < l; i++) {
//                 var c = children[i];
//                 c._renderFlag |= CHILDREN;
//             }
//         }
//     }
// }();

let _cullingMask = 0;
cc.RenderFlow.prototype["_children"] = function (node) {
    let cullingMask = _cullingMask;
    let batcher = cc.RenderFlow['getBachther'](); // _batcher;

    let parentOpacity = batcher.parentOpacity;
    let opacity = (batcher.parentOpacity *= (node._opacity / 255));

    let worldTransformFlag = batcher.worldMatDirty ? WORLD_TRANSFORM : 0;
    let worldOpacityFlag = batcher.parentOpacityDirty ? OPACITY_COLOR : 0;
    let worldDirtyFlag = worldTransformFlag | worldOpacityFlag;

    let children = node._children;

    var isRenderList;
    // 修改开始
    if (node._renderChildren) {
        isRenderList = true;
        children = node._renderChildren;
    }
    // 修改结束
    for (let i = 0, l = children.length; i < l; i++) {
        let c = children[i];

        // 修改开始
        if (isRenderList) {
            if (!c || !c.parent) {
                // cc.log('---错误');
                continue;
            }
            c._renderFlag &= ~CHILDREN;
            
            opacity = c.parent._opacity / 255;
        }
        // 修改结束

        // Advance the modification of the flag to avoid node attribute modification is invalid when opacity === 0.
        c._renderFlag |= worldDirtyFlag;
        if (!c._activeInHierarchy || c._opacity === 0) continue;

        _cullingMask = c._cullingMask = c.groupIndex === 0 ? cullingMask : 1 << c.groupIndex;

        // TODO: Maybe has better way to implement cascade opacity
        let colorVal = c._color._val;
        c._color._fastSetA(c._opacity * opacity);
        cc.RenderFlow['flows'][c._renderFlag]._func(c);
        c._color._val = colorVal;

        // 修改开始
        if (isRenderList) {
            c._renderFlag |= CHILDREN;
        }
        // 修改结束
    }

    batcher.parentOpacity = parentOpacity;
    this._next._func(node);
}

cc.RenderFlow['visitRootNode'] = function (rootNode) {
    cc.RenderFlow['validateRenderers'](); 

    let _batcher = cc.RenderFlow['getBachther']();
    let flows = cc.RenderFlow['flows'];

    let preCullingMask = _cullingMask;
    _cullingMask = rootNode._cullingMask;

    if (rootNode._renderFlag & WORLD_TRANSFORM) {
        _batcher.worldMatDirty ++;
        rootNode._calculWorldMatrix();
        rootNode._renderFlag &= ~WORLD_TRANSFORM;

        flows[rootNode._renderFlag]._func(rootNode);

        _batcher.worldMatDirty --;
    }
    else {
        flows[rootNode._renderFlag]._func(rootNode);
    }

    _cullingMask = preCullingMask;
};

